import { format, parse, setDate, setMonth, subDays, subMonths, subYears, } from "date-fns";
import { dateFormat } from "../Shared";
export function getStartDateFromTimeFrame(timeFrame, customTimeFrame, from) {
    const dateRange = calculateDateRangeFromTimeFrame(timeFrame, customTimeFrame, from);
    const startDateFromTimeFrame = dateRange?.startDate;
    return startDateFromTimeFrame !== undefined
        ? parse(startDateFromTimeFrame, dateFormat, new Date())
        : null;
}
export function calculateDateRangeFromTimeFrame(timeFrame, customTimeFrame, from) {
    let inThePast = from;
    switch (timeFrame) {
        case "30D":
            inThePast = subDays(from, 30);
            break;
        case "3M":
            inThePast = subMonths(from, 3);
            break;
        case "6M":
            inThePast = subMonths(from, 6);
            break;
        case "YTD":
            inThePast = setMonth(setDate(from, 1), 0);
            break;
        case "1Y":
            inThePast = subYears(from, 1);
            break;
        case "ALL":
            return null;
        case "Custom":
            if (customTimeFrame === null) {
                throw new Error("timeFrame === Custom but customTimeFrame is null [calculateDateRangeFromTimeFrame]");
            }
            return customTimeFrame;
        default:
            return null;
    }
    return {
        startDate: format(inThePast, dateFormat),
        endDate: format(from, dateFormat),
    };
}
//# sourceMappingURL=timeframes.js.map